import React from 'react';
import { withRouter } from 'react-router-dom';
var constants = require("../constants/constants");
var axios = require('axios');
class TransportHomePage extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            isVehicleFillInformation: false,
            isSupervisorFillInformation: false,
            isemployeFillInformation: false,
            isBlackListInformation: false,
            isBlackListKamgarInformation: false,
            CompanyId: CompanyId,
            AdharCardNo: '',
            QuerType: ''
        };
    }
    //Button method
    VehicleFillInformation(e, CompanyId) {
        this.setState({
            isVehicleFillInformation: true
        });
        this.props.history.push({
            pathname: '/VehicleFillInfo_Show_Details',
            CompanyId: localStorage.getItem('CompanyId') || 1,
        })
    }

    SupervisorFillInformation(e, CompanyId) {
        this.setState({
            isSupervisorFillInformation: true
        });
        this.props.history.push({
            pathname: '/MukadamFillInfo_Show_Details',
            CompanyId: localStorage.getItem('CompanyId') || 1,
        })
    }

    employeFillInformation(e, CompanyId) {
        this.setState({
            isemployeFillInformation: true
        });
        this.props.history.push({
            pathname: '/KamgarFillInfo_Show_Details',
            CompanyId: localStorage.getItem('CompanyId') || 1,
        })
    }

    BlackListMukadamInformation(e, CompanyId) {
        this.setState({
            isBlackListInformation: true
        });
        this.props.history.push({
            pathname: '/BlackListShow',
            CompanyId: localStorage.getItem('CompanyId') || 1,
        })
    }

    BlackListkamgarInformation(e, CompanyId) {
        this.setState({
            isBlackListKamgarInformation: true
        });
        this.props.history.push({
            pathname: '/BlaclkListkamgarShow',
            CompanyId: localStorage.getItem('CompanyId') || 1,
        })
    }

    //search blacklisted persons in any other factory
    searchBlackListed(AdharCardNo) {
        let currentComponent = this;
        //  var user = JSON.parse(sessionStorage.getItem("User"));
        axios.get(constants.config.HOST + constants.api.SEARCH_BALCKLISTED_NAME, {
            params: {
                AdharCardNo: this.state.AdharCardNo,
                QueryType: 'Mukadam'
            }
        })
            .then(function (response) {
                currentComponent.setState({ BlacklistedInfo: response.data })
                console.log(response.data)
            }).catch(function (error) {
                console.log(error);
            });
    }
    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                            <div className="navbar_right">
                                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <div className="loginform">
                                <form id="LoginForm" method="post">
                                    <div  >
                                        <input type="Submit" className="form_submit" onClick={(e) => this.VehicleFillInformation(e, this.props.location.CompanyId)} value="वाहनांची माहिती भरण्यासाठी" /> </div>
                                    <div><input type="Submit" className="form_submit" onClick={(e) => this.SupervisorFillInformation(e, this.props.location.CompanyId)} value="मुकादामांची  माहिती भरण्यासाठी" /></div>
                                    <div><input type="Submit" className="form_submit" onClick={(e) => this.employeFillInformation(e, this.props.location.CompanyId)} value="उसतोडणी कामगारांची माहिती भरण्यासाठी" /></div>
                                    <div><input type="Submit" className="form_submit" onClick={(e) => this.BlackListMukadamInformation(e, this.props.location.CompanyId)} value="ब्लॅकलिस्ट केलेले  पाहण्यासाठी " /></div>
                                </form><br /><br />
                                <div>
                                    {
                                        (this.state.BlacklistedInfo != null || this.state.BlacklistedInfo != undefined) ?
                                            this.state.BlacklistedInfo.map(function (worker, index) {
                                                return (
                                                    <tr>
                                                        <div style={{ padding: '13px 20px 20px 13px' }} className="card ">
                                                            <h4>   <b> कामगाराचे नाव : <b style={{ 'color': '#3700B3' }}> {worker.fullname}</b></b><br /> </h4>
                                                            <h4>   <b> वाहतुकदाराचे नाव :<b style={{ 'color': '#3700B3' }}>  {worker.FullName}</b></b> </h4>
                                                            <h4>   <b> कारखान्याचे नाव  :<b style={{ 'color': '#3700B3' }}>  {worker.CompanyName}</b></b> </h4>
                                                        </div>
                                                    </tr>
                                                )
                                            })
                                            : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(TransportHomePage);


// WEBPACK FOOTER //
// ./src/component/TransportHomePage.jsx